/**
 * Shared end-time semantics. Both nulls mean an intentionally open-ended
 * meeting; a duration without an explicit end retains the derived end.
 * Pure and safe to import from either server or client code.
 */
export interface MeetingEndInput {
  startsAt: Date | null
  endsAt: Date | null
  scheduledMinutes: number | null
}

const MS_PER_MINUTE = 60_000

export function resolveMeetingEndMs(meeting: MeetingEndInput): number | null {
  if (meeting.endsAt !== null) return meeting.endsAt.getTime()
  if (meeting.scheduledMinutes === null || meeting.startsAt === null) {
    return null
  }
  return meeting.startsAt.getTime() + meeting.scheduledMinutes * MS_PER_MINUTE
}

export function meetingHasEnd(meeting: MeetingEndInput): boolean {
  return meeting.endsAt !== null || meeting.scheduledMinutes !== null
}

/** Keep stored agenda budgets; derive one when a no-end meeting gains an end. */
export function resolveMeetingBudgetMinutes(
  meeting: MeetingEndInput,
): number | null {
  if (meeting.scheduledMinutes !== null) return meeting.scheduledMinutes
  const end = resolveMeetingEndMs(meeting)
  return end !== null && meeting.startsAt !== null
    ? Math.max(
        1,
        Math.round((end - meeting.startsAt.getTime()) / MS_PER_MINUTE),
      )
    : meeting.scheduledMinutes
}
